import React, { Component } from 'react'
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import { Link } from 'react-router-dom';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import StoreIcon from '@mui/icons-material/Store';
import GroupsIcon from '@mui/icons-material/Groups';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RealEstateAgentIcon from '@mui/icons-material/RealEstateAgent';
import EarbudsIcon from '@mui/icons-material/Earbuds';
import PaidIcon from '@mui/icons-material/Paid';



export class Sidebar extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       first:''
    }
  }
  render() {

    let currentLocation = window.location.pathname

    return (
      <div>
<Paper elevation={1} sx={{display:{xs:'none',sm:'block'},backgroundColor:'#444b52',width:80,minHeight:'93vh',borderRadius:0,position:'static'}}>

<Link to='/admin/dashboard'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/admin/dashboard'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<DashboardOutlinedIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Dashboard</Typography>
</Box> 
</Link>

<Link to='/admin/builder'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/admin/builder'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<ManageAccountsIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Profile</Typography>
</Box> 
</Link>


<Link to='/admin/addProperty'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/admin/addProperty'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<RealEstateAgentIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Add Property</Typography>
</Box> 
</Link>


<Link to='/admin/propertyList'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/admin/propertyList'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<EarbudsIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Property List</Typography>
</Box> 
</Link>


<Link to='/admin/transaction'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/admin/transaction'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<PaidIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Payment</Typography>
</Box> 
</Link>






</Paper>
      </div>
    )
  }
}

export default Sidebar